import InputField from "../../../components/InputField";
import OptionalFields from "../../../components/OptionalFields";
import Toggle from "../../../components/Toggle";

export default function CumparatorStep({ data, errors, update }) {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
      <div style={{ width: "100%" }}>
        <Toggle
          label="Persoana juridica"
          description="Cumparatorul este o firma / societate comerciala"
          checked={!!data.cumparatorPJ}
          onChange={() => update("cumparatorPJ")(!data.cumparatorPJ)}
        />
      </div>

      {data.cumparatorPJ ? (
        <>
          <InputField label="Denumire societate" value={data.cumparatorFirma} onChange={update("cumparatorFirma")} placeholder="ex: SC Exemplu SRL" required error={errors.cumparatorFirma} />
          <InputField label="CUI" value={data.cumparatorCUI} onChange={update("cumparatorCUI")} placeholder="ex: RO12345678" required half error={errors.cumparatorCUI} />
          <InputField label="Nr. Reg. Comertului" value={data.cumparatorRegCom} onChange={update("cumparatorRegCom")} placeholder="ex: J40/1234/2020" half error={errors.cumparatorRegCom} />
          <InputField label="Sediu social" value={data.cumparatorSediu} onChange={update("cumparatorSediu")} placeholder="ex: Str. Alta nr. 5, Cluj-Napoca" required error={errors.cumparatorSediu} />
          <InputField label="Reprezentant legal" value={data.cumparatorReprezentant} onChange={update("cumparatorReprezentant")} placeholder="ex: Ionescu Maria" required error={errors.cumparatorReprezentant} />
        </>
      ) : (
        <>
          <InputField label="Nume complet" value={data.cumparatorNume} onChange={update("cumparatorNume")} placeholder="ex: Ionescu Maria" required error={errors.cumparatorNume} />
          <InputField label="Adresa de domiciliu" value={data.cumparatorAdresa} onChange={update("cumparatorAdresa")} placeholder="ex: Str. Alta nr. 5, Cluj-Napoca" required error={errors.cumparatorAdresa} />
          <OptionalFields>
            <InputField label="CNP" value={data.cumparatorCNP} onChange={update("cumparatorCNP")} placeholder="ex: 2234567890123" half error={errors.cumparatorCNP} helperText="Opțional — poți completa de mână pe document" />
            <InputField label="Serie si nr. CI" value={data.cumparatorCI} onChange={update("cumparatorCI")} placeholder="ex: MZ 654321" half error={errors.cumparatorCI} helperText="Opțional — poți completa de mână pe document" />
          </OptionalFields>
        </>
      )}
    </div>
  );
}
